import {myEnrollmentsApi} from '@/api/my-enrollments.api.js'

/**
 * Enrollment by code
 */
export const useEnrollmentByCode = () => {

  //Wrapper around API
  const enrollByCode = message => myEnrollmentsApi.enrollByCode(message.getCreateJson())

  //Expose interface
  return {
    enrollByCode,
  }
}
